import {ItemCountView} from '../../ui_canvas_engine/ItemCountView'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from './UIGamePlayerInformationView'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {VictoryPointStateReader, VictoryPointTypes} from '@colonist/game-base-types'
import {UIGameMechanic} from '../UIGameEventController'
import {TranslationObject} from '@colonist/i18n'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'

export abstract class UIGamePlayerInformationProgressCardVictoryPointView implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    protected readonly isMyPlayer: boolean
    protected readonly playerInformation: UIGamePlayerInformationView
    protected progressCardVictoryPointView: ItemCountView

    constructor(uiGameManager: UIGameManager, playerInformation: UIGamePlayerInformationView) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.playerInformation = playerInformation

        const bottomPlayerColor = this.uiGameManager.gameController.isPlayerSpectator ? this.uiGameManager.gameController.playOrder[0] : this.uiGameManager.gameController.myColor
        this.isMyPlayer = this.playerInformation.player.color == bottomPlayerColor
        this.isMyPlayer ? this.createMyProgressCardVictoryPointView() : this.createOpponentProgressCardVictoryPointView()
        this.createTooltip()
        this.updateProgressCardVictoryPointCount()
        this.toggleProgressCardVictoryPointView()
    }

    private createTooltip() {
        if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return
        const progressCardVictoryPointTipTitle: TranslationObject = {key: 'strings:game.playerInformation.progressCardVictoryPoint.title'}
        const progressCardVictoryPointTipBody: TranslationObject = {key: 'strings:game.playerInformation.progressCardVictoryPoint.body'}
        this.progressCardVictoryPointView.view.setTip(progressCardVictoryPointTipTitle, [progressCardVictoryPointTipBody])
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated: this.updateProgressCardVictoryPointCount(); break
            case UIGameEventEnums.HoveredOverPlayerInformationArrow: this.progressCardVictoryPointView.showView(this.playerInformation); break
            case UIGameEventEnums.PointerOutPlayerInformationView: this.progressCardVictoryPointView.hideView(); break
            default: break
        }
    }

    protected abstract createMyProgressCardVictoryPointView(): void
    protected abstract createOpponentProgressCardVictoryPointView(): void

    private updateProgressCardVictoryPointCount() {
        const victoryPointsFromProgressCards = VictoryPointStateReader.totalVictoryPointsOfType(this.playerInformation.playerState.victoryPointsState, [VictoryPointTypes.ProgressCardVictoryPoint])
        this.progressCardVictoryPointView.updateText({key: 'strings:colonistCommon.utils.#buffer', options: {value: victoryPointsFromProgressCards}})
    }

    protected toggleProgressCardVictoryPointView() {
        if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return
        this.progressCardVictoryPointView.view.parent == undefined ? this.progressCardVictoryPointView.showView(this.playerInformation) : this.progressCardVictoryPointView.hideView()
    }

    destroy() {
        this.uiGameManager.eventController.unregisterUIGameMechanic(this)
    }
}
